export default __webpack_public_path__ + "static/media/round-arrow.6944b064.svg";